<template>
  <div class="announce containerWidth">
    <van-row>
      <van-col span="8" class="text_b">
        <div>
          <p>快来围观，</p>
          <p>一起见证辛运儿～</p>
          <router-link to="/pointsMall/lottery">查看更多</router-link>
        </div>
      </van-col>
      <van-col span="16" class="swiper_b">
        <div class="swiper-wrapper" style="overflow-y: auto">
          <div
            class="swiper-slide"
            v-for="(item, index) in lotteryData"
            :key="item.id + 'cateogry' + index"
          >
            <!-- <router-link :to="'/pointsMall/detail?id=' + item.id + '&sid='+item.peroid_id+  -->
            <router-link
              :to="'/pointsMall/detail?id=' + item.id + '&pid=' + item.sid"
              :key="item.id + 'ccc' + index"
            >
              <div class="imgs">
                <img :src="item.image" :alt="item.title" />
                <p class="tips">第{{ item.qishu || 0 }}件</p>
              </div>
              <div class="text">
                <p class="title">
                  {{ item.times == 0 ? "换得者" : "倒计时" }}
                </p>
                <p class="clamp1" v-if="item.times <= 0">
                  {{ item.user.username || "" }}
                </p>
                <p v-else>
                  <VueCountdownTimer
                    :key="item.sid"
                    class="van-count-down"
                    ref="cxlCountdown"
                    :time="item.times * 1000 || null"
                    :interval="1000"
                    :emit-events="events"
                    :items="item"
                    :format="transform"
                    :enableVisibilityHiddenFix="true"
                    @finish="finish(index, item)"
                  >
                    <template v-slot="props">
                      <span class="minutes block" v-text="props.minutes" />
                      <span class="separator colon">:</span>
                      <span class="seconds block" v-text="props.seconds" />
                      <span class="separator colon">:</span>
                      <span class="countdown-number block" />
                    </template>
                  </VueCountdownTimer>
                  <!-- <van-count-down
                    :key="item.sid"
                    :time="item.times * 1000 || null"
                    millisecond
                    format="mm:ss:SS"
                    @change="
                      (e) => {
                        changCount(e, item);
                      }
                    "
                    @finish="finish(index, item)"
                  >
                    <template #default="timeData">
                      <span class="block">0{{ timeData.minutes }}</span>
                      <span class="colon">:</span>
                      <span class="block">{{ timeData.seconds }}</span>
                      <span class="colon">:</span>
                      <span class="block">{{
                        String(timeData.milliseconds)
                          .padStart(3, "0")
                          .substr(0, 2)
                      }}</span>
                    </template>
                  </van-count-down> -->
                </p>
              </div>
            </router-link>
          </div>
        </div>

        <!-- <swiperx :swiperOptions="swiperOptions"> -->
        <!-- <template #slides> -->
        <!-- <ItemCom
              v-for="(item, index) in dc"
              :key="item.id"
              :item="item"
              :index="index"
            /> -->

        <!-- </template> -->
        <!-- </swiperx> -->
      </van-col>
    </van-row>
    <!-- 中奖弹窗 -->
    <van-overlay :show="jackpotVis" @click="jackpotVis = false">
      <router-link
        to="/user/userProduct"
        class="wrapper"
        @click.stop
        style="max-width: 500px"
      >
        <img src="@/static/images/jackpotVis.png" style="width: 100%" />
        <h2 class="title clamp2">
          (第{{ jackpotData?.qishu }}件){{ jackpotData?.name }}
        </h2>
      </router-link>
    </van-overlay>
  </div>
</template>
<script>
import api from "@/request/api";
import swiperx from "@/components/swiperx.vue";
import { swiperSlide } from "vue-awesome-swiper";
// import ItemCom from "../components/addItem";
export default {
  name: "announceCom",
  components: {
    swiperx,
    swiperSlide,
    // ItemCom,
  },
  data() {
    return {
      dc: [],
      swiperOptions: {
        slidesPerView: "auto",
        freeMode: true,
      },
      lotteryData: [],
      timer: null,
      timestampWithDecimal: null,
      jackpotVis: false,
      uid: null,
      jackpotData: null,
      events: {
        visibilityVisible: true,
        visibilityHidden: true,
        finish: true,
      },
    };
  },
  created() {
    this.uid = localStorage.getItem("info")
      ? JSON.parse(localStorage.getItem("info")).uid
      : null;
    this.getHttp();
  },
  mounted() {},
  destroyed() {
    this.lotteryData = [];
    this.timer = null;
    clearInterval(this.timer);
  },
  methods: {
    transform(props) {
      props.items.time = props.totalSeconds;
      props.items.times = props.totalSeconds;
      Object.entries(props).forEach(([key, value]) => {
        props[key] = value < 10 ? `0${value}` : value;
      });
      return props;
    },
    generateUniqueKey() {
      const currentTimestamp = Date.now(); // 当前时间戳
      return `${currentTimestamp}`; // 唯一组合
    },
    getTimer() {
      var this_ = this;
      this.timer = setInterval(() => {
        var timestamp = Date.now();
        const timestampWithDecimal = (timestamp / 1000).toFixed(3);
        this_.lottery_going_shoplist(
          this_.timestampWithDecimal
            ? this_.timestampWithDecimal
            : timestampWithDecimal,
          1
        );
      }, 1000);
    },
    async getHttp() {
      try {
        const [index_lotteryData] = await Promise.all([
          this.get_index_lotteryAll(),
        ]);
        if (index_lotteryData.status === 200) {
          if (index_lotteryData.data[0].times <= 0) {
            this.thttp(index_lotteryData.data);
          } else {
            this.timestampWithDecimal = index_lotteryData.data[0].q_end_time;
            this.lotteryData = index_lotteryData.data;
            this.getTimer();
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 二次请求
    async thttp(dt) {
      try {
        const timestampWithDecimal = (Date.now() / 1000).toFixed(3);
        const [result] = await Promise.all([
          this.getLottery(timestampWithDecimal),
        ]);
        if (result.status == 200) {
          this.timestampWithDecimal = result.data.maxSeconds;
          if (result.data.listItems.length > 0) {
            this.lotteryData = [...result.data.listItems, ...dt];
          } else {
            this.lotteryData = dt;
          }
          this.getTimer();
        }
      } catch (error) {
        this.lotteryData = dt;
        console.error(error);
      }
    },
    // 获取信息
    async get_index_lottery() {
      var this_ = this;
      try {
        const result = await api.store_integral.get_index_lottery();
        if (result.status == 200) {
          this_.lotteryData = result.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async get_index_lotteryAll() {
      return api.store_integral.get_index_lottery();
    },
    // 获取开奖人员
    async finish(index, data) {
      const result = await api.store_integral.barcoderWinInfo({
        productId: data.sid,
      });
      if (result.status == 200) {
        this.lotteryData[index].user = result.data;
        this.lotteryData[index].times = 0;
        if (parseInt(result.data.uid) == parseInt(this.uid)) {
          this.jackpotData = {
            ...result.data,
            name: data.title,
            qishu: data.qishu,
          };
          // this.jackpotVis = true;
        }
      }
    },
    // 获取最新数据
    async lottery_going_shoplist(data, type) {
      try {
        const result = await api.store_integral.lottery_going_shoplist(
          data,
          type
        );
        this.timestampWithDecimal = result.data.maxSeconds;
        if (result.status == 200) {
          if (result.data.listItems.length > 0) {
            // 将最新数据插入到数组的开头
            result.data.listItems = result.data.listItems.map((item) => {
              return { ...item, peroid_id: item.qishu };
            });
            if (result.data.listItems.length > 0) {
              for (
                let index = 0;
                index < result.data.listItems.length;
                index++
              ) {
                const element = result.data.listItems[index];
                this.lotteryData.unshift({
                  ...element,
                  peroid_id: element.qishu,
                });
              }
            }

            if (this.lotteryData.length > 10) {
              // 删除多余的元素
              while (this.lotteryData.length > 10) {
                if (this.lotteryData.length > 0) {
                  // 如果 lotteryData 数组还有元素，删除最后一个元素
                  this.lotteryData.pop();
                }
              }
            }

            this.lotteryData.sort((a, b) => b.times - a.times);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    // all 请求
    async getLottery(data) {
      return api.store_integral.lottery_going_shoplist(data, 1);
    },
    changCount(e, count) {
      const totalSeconds =
        e.days * 86400 +
        e.hours * 3600 +
        e.minutes * 60 +
        e.seconds +
        e.milliseconds / 1000;
      count.times = totalSeconds;
    },
  },
};
</script>
<style lang="scss">
.van-overlay {
  z-index: 999 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    position: relative;
    .title {
      height: 0.85rem;
      width: 3.75rem;
      text-align: center;
      position: absolute;
      bottom: 1.42rem;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      font-size: 0.3rem;
    }
  }
}

@media screen and (min-width: 300px) and (max-width: 700px) {
  .swiper-wrapper::-webkit-scrollbar {
    display: none;
  }
}
</style>
